import {AfterViewInit, Component, forwardRef, Inject} from '@angular/core';
import {KioskManageService} from '../../../../services/kiosk-manage.service';
import {IngredientStateBean} from '../../../../model/model';
import {AppComponent} from '../../../../app.component';

@Component({
    selector: 'kiosk-ingredients-component',
    templateUrl: 'kiosk-ingredients.component.html'
})
export class KioskIngredientsComponent implements AfterViewInit {

    ingredients: IngredientStateBean[];
    kioskId: number;

    constructor(private kioskManageService: KioskManageService,
        @Inject(forwardRef(() => AppComponent)) private app: AppComponent) {
    }

    ngAfterViewInit(): void {
    }

    onShow(kioskId: number, operatorId: number) {
        this.kioskId = kioskId;
        this.kioskManageService.getIngredients(kioskId).subscribe(response => {
            if (response.success) {
                this.ingredients = response.value;
            }
        });
    }

    save() {
        this.kioskManageService.setIngredients(this.kioskId, this.ingredients).subscribe(response => {
            if (response.success) {
                this.app.showNotification('Updated');

            } else {
                this.app.showError('Can\'t update kiosk');
            }
        }, error => {
            this.app.showError('Can\'t update kiosk');
        });
    }
}
